import { Search } from "lucide-react";
import { Input, TFocus } from "./input";
import { Dispatch, SetStateAction } from "react";
import { cn } from "@/lib/class-control";

interface InputSearchProps {
  focus?: TFocus
  className?: string
  classNameIcon?: string
  classNameContainer?: string
  positionIcon: "start" | "end"
  placeholder?: string
  value: string
  onChange: Dispatch<SetStateAction<string>>
  ariaLabel?: string
}

export default function InputSearch(props: InputSearchProps) {
  const componentIcon = () => (
    <Search className={cn(
      "size-4 text-white",
      props.classNameIcon
    )} />
  )

  return (
    <Input
      type="text"
      placeholder={props.placeholder || "Procurar..."}
      value={props.value}
      onChange={(e) => props.onChange(e.target.value)}
      focus={props.focus}
      aria-label={props.ariaLabel}
      className={cn(
        "text-white text-xs placeholder:text-gray-300 rounded-md",
        props.className
      )}
      classNameContainer={cn(
        "w-52 h-8",
        props.classNameContainer
      )}
      start={props.positionIcon === "start" ? componentIcon() : undefined}
      end={props.positionIcon === "end" ? componentIcon() : undefined}
    />
  )
}
